<template>
  <div class="xu-cascader">
    <van-field
      v-model="fieldValue"
      is-link
      readonly
      label=""
      placeholder=""
      @click="cascaderShow = true"
    />
    <!-- @finish="onFinish" -->
    <van-popup v-model="cascaderShow" round position="bottom" get-container="#app">
      <van-cascader
        v-model="cascaderValue"
        :closeable="false"
        :title="$t('form.pleaseSelect')"
        :options="deptOption"
        active-color="#307bff"
        @close="cascaderShow = false"
        @change="handleCascaderChange"
        :field-names="fieldNames"
      >
        <div slot="title" class="cascader-header">
          <span class="title-txt">{{ $t('form.pleaseSelect') }}</span>
          <div>
            <van-button type="info" size="mini" @click="handleClear">{{ $t('button.clear') }}</van-button>
            <van-button type="info" size="mini" @click="onFinish">{{ $t('button.confirm') }}</van-button>
          </div>
        </div>
      </van-cascader>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    deptOption: {
      type: Array,
      default: () => []
    },
    fieldNames: {
      type: Object,
      default: () => {
        return {
          text: 'label', value: 'id', children: 'children'
        }
      }
    }
  },
  data () {
    return {
      fieldValue: '',
      cascaderValue: '',
      cascaderShow: false,
      currentLabel: []
    }
  },
  methods: {
    onFinish () {
      // this.cascaderShow = false
      // this.fieldValue = selectedOptions.map((option) => option.label).join('/')
      // this.$emit('input', [this.cascaderValue])
      this.cascaderShow = false
      this.fieldValue = this.currentLabel.map((option) => option.label).join('/')
      this.$emit('input', [this.cascaderValue])
    },
    handleClear () {
      this.cascaderShow = false
      this.fieldValue = ''
      this.cascaderValue = ''
      this.$emit('input', [])
    },
    handleCascaderChange (val) {
      this.currentLabel = val.selectedOptions
    }
  }
}
</script>

<style lang="less" scoped>
.xu-cascader {
  width: 100%;
  margin-bottom: 5px;
}
/deep/.van-field {
  width: 100%;
  border: 1px solid #eee;
  padding: 5px 10px;
  .van-field__body {
    font-size: 12px;
  }
}
/deep/.van-cascader__title {
  width: 100%;
}
.cascader-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-txt {
    margin-right: 10px;
  }
}
</style>
